import React from 'react';

import * as S from './SmartEngageUI.styles';
import useCarousel from '../../../../../shared/hooks/useCarousel';
import RightArrowNewIconHome from '../../../../../stories/Icons/ArrowRightNew';
import LeftArrowNewIcon from '../../../../../stories/Icons/ArrowLeftNew';

export interface IBannerData {
  banner_type?: number;
  img_url?: string;
  slug?: string;
  cta_type?: string;
  name?: string;
  cta_url?: string;
}

const SmartEngageCarousel = ({carouselDataList = []}) => {
  const {increment, decrement, isLeftCursorActive, isRightCursorActive, dataList} = useCarousel(
    carouselDataList,
    1,
  );

  const toShowBannerData = dataList[0];

  return (
    <>
      {toShowBannerData.ctaUrl ? (
        <a href={toShowBannerData.ctaUrl} target="_blank" rel="noopener">
          <S.ImageBannerContainer src={toShowBannerData.image} alt={toShowBannerData.image} />
        </a>
      ) : (
        <S.ImageBannerContainer src={toShowBannerData.image} alt={toShowBannerData.image} />
      )}

      {!!isRightCursorActive && (
        <S.SliderArrowRight
          onClick={() => {
            increment();
          }}
        >
          <RightArrowNewIconHome />
        </S.SliderArrowRight>
      )}

      {!!isLeftCursorActive && (
        <S.SliderArrowLeft
          onClick={() => {
            decrement();
          }}
        >
          <LeftArrowNewIcon />
        </S.SliderArrowLeft>
      )}
    </>
  );
};

const SmartEngageUI = ({dataList = []}) => {
  if (!dataList.length) {
    return null;
  }

  return <SmartEngageCarousel carouselDataList={dataList} />;
};

export default SmartEngageUI;
